// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('GenerationResponseVO')
export class GenerationResponseVO {

  @JsonProperty('contentId', 'string')
  public contentId: string;

  @JsonProperty('content', 'string')
  public content: string;

  @JsonProperty('contentUrl', 'string')
  public contentUrl: string;

  @JsonProperty('contentGenerated', 'boolean')
  public contentGenerated: boolean;
}
